export default __webpack_public_path__ + "static/media/Emergency power supply rooms.b72f6114.png";